var _desc, _style, _circle, _g, _g2, _path, _g3, _circle2, _circle3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmptyPlane(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 240 200",
    width: 240,
    height: 200,
    role: "img",
    "aria-labelledby": titleId,
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "empty-plane-title"
  }, "Ei viel\xE4 viestej\xE4") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "empty-plane-title"
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", {
    id: "empty-plane-desc"
  }, "Paperilennokki lent\xE4\xE4 pilvien v\xE4liss\xE4 katkoviivareitti\xE4 pitkin")), _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n    .empty-plane-accent { fill: var(--empty-accent, #6366f1); }\n    .empty-plane-stroke { stroke: var(--empty-accent, #6366f1); }\n    .empty-plane-muted  { fill: var(--empty-muted, #e0e7ff); }\n    .empty-plane-surface{ fill: var(--empty-surface, #ffffff); }\n    .empty-plane-line   { stroke: var(--empty-line, #c7d2fe); }\n    .empty-plane-plane  { animation: empty-plane-bob 3.2s ease-in-out 2; }\n    @keyframes empty-plane-bob   { 0%,100% { transform: translate(0,0); } 50% { transform: translate(3px,-6px); } }\n    @media (prefers-reduced-motion: reduce) { .empty-plane-plane { animation: none; } }\n  ")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 120,
    cy: 104,
    r: 84,
    className: "empty-plane-muted",
    opacity: 0.55
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "empty-plane-cloud"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M52 78 a10 10 0 0 1 4 -19 a14 14 0 0 1 26 -2 a10 10 0 0 1 4 21 Z",
    className: "empty-plane-surface empty-plane-line",
    strokeWidth: 2
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "empty-plane-cloud empty-plane-b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M150 158 a9 9 0 0 1 3 -17 a12 12 0 0 1 23 -2 a9 9 0 0 1 3 19 Z",
    className: "empty-plane-surface empty-plane-line",
    strokeWidth: 2
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "empty-plane-line empty-plane-trail",
    d: "M36 160 C70 176 96 140 92 118 C88 98 112 92 128 104 C140 113 150 104 160 94",
    fill: "none",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeDasharray: "6 6"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    className: "empty-plane-plane"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M156 86 L204 58 L186 108 L172 96 Z",
    className: "empty-plane-surface empty-plane-stroke",
    strokeWidth: 2,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172 96 L204 58 L168 104 Z",
    className: "empty-plane-accent",
    opacity: 0.35
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172 96 L204 58",
    className: "empty-plane-stroke",
    strokeWidth: 2,
    strokeLinecap: "round"
  }))), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 196,
    cy: 128,
    r: 3,
    className: "empty-plane-accent",
    opacity: 0.3
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 44,
    cy: 110,
    r: 2.5,
    className: "empty-plane-accent",
    opacity: 0.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyPlane);
export default __webpack_public_path__ + "static/media/empty-plane.4643772ca3f86235583e6d431378c962.svg";
export { ForwardRef as ReactComponent };